import type { Except } from "type-fest";
import { z } from "zod";
import { orderGroupIdZodSchema } from "../order-groups/order-group-id";
import { orderEventIdZodSchema } from "../orders/order-events/events/_order-event-id";
import { orderIdZodSchema } from "../orders/order-id";
import { providerIdZodSchema } from "../providers/provider-id";
import { paymentCancellationZodUnion } from "./cancellations/payment-cancellation";
import {
    managePaymentCommandIdFactory,
    managePaymentCommandIdZodSchema,
} from "./manage-payment-command-id";
import { newManagedPaymentZodDiscriminatedUnion } from "./new-managed-payments/new-managed-payment";

const managePaymentCommandZodObject = z.object({
    _id: managePaymentCommandIdZodSchema,
    _type: z.literal("MANAGE_PAYMENT_COMMAND"),
    /** Payment changes is made for given order and triggered by given order event id */
    paymentFor: z.object({
        orderGroupId: orderGroupIdZodSchema,
        orderId: orderIdZodSchema,
        providerId: providerIdZodSchema,
        orderEventIds: z.array(orderEventIdZodSchema),
    }),
    /** Payment cancellations part of change */
    cancellations: z.array(paymentCancellationZodUnion),
    /** New managed payments replacing the cancellations */
    newPayment: newManagedPaymentZodDiscriminatedUnion.optional(),
});
type ManagePaymentCommand = z.infer<typeof managePaymentCommandZodObject>;

type FactoryParams = Except<ManagePaymentCommand, "_type" | "_id">;
const managePaymentCommandFactory = (params: FactoryParams) => {
    const command: ManagePaymentCommand = {
        ...params,
        _id: managePaymentCommandIdFactory(),
        _type: "MANAGE_PAYMENT_COMMAND",
    };
    return command;
};

export { managePaymentCommandFactory, managePaymentCommandZodObject };
export type { ManagePaymentCommand };
